import { createSelector } from "reselect"


export function meetingTransactionsLoadingStarted(state = false, action) {
  switch (action.type) {
    case "MEETING_TRANSACTION_LOAD_START":
      return action.isloading
    default:
      return state
  }
}

export function meetingTransactionLoadingError(state = false, action) {
  switch (action.type) {
    case "MEETING_TRANSACTION_LOAD_ERROR":
      return action.error
    default:
      return state
  }
}

export const currentMeetingTransactions = (state) => state.meetingTransactions
export const currentMemberName = (state) => state.loadedMember?.full_name
export const transactionType = (state) => state.currentTransactionContext

export const selectMemberTrasactions = createSelector(
  currentMeetingTransactions,
  currentMemberName,
  transactionType,
  (transactions, name, type) => {
    return transactions
      .filter((transaction) => transaction.full_name === name)
      .filter((transaction) => transaction.transaction_type === type)
      .filter((transaction) => transaction.reversal === false)
  },
)

export const selectMemberReversedWriteOffTrasactions = createSelector(
  currentMeetingTransactions,
  currentMemberName,
  transactionType,
  (transactions, name) => {
    return transactions
      .filter((transaction) => transaction.full_name === name)
      .filter((transaction) => transaction.transaction_type === "Loan write-off")
      .filter((transaction) => transaction.reversal === false)
  },
)

export const selectMemberReversedLoanPaidTrasactions = createSelector(
  currentMeetingTransactions,
  currentMemberName,
  transactionType,
  (transactions, name) => {
    return transactions
      .filter((transaction) => transaction.full_name === name)
      .filter((transaction) => transaction.transaction_type === "Loan repaid")
      .filter((transaction) => transaction.reversal === false)
  },
)
